import React from 'react';
import type { PlanReviewPageGroup } from '../../utils/planReviewSummary';

export interface PlanReviewSummaryPreviewProps {
  commentGroups: PlanReviewPageGroup[];
  emptyMessage?: string;
}

/** Shared read-only preview of plan-review annotation slices (modal + complete flow). */
export default function PlanReviewSummaryPreview({
  commentGroups,
  emptyMessage = 'No PDF comments were added during this review.',
}: PlanReviewSummaryPreviewProps) {
  if (commentGroups.length === 0) {
    return <p className="plan-review-complete-preview-empty">{emptyMessage}</p>;
  }

  return (
    <div className="plan-review-complete-preview">
      {commentGroups.map((group) => (
        <div key={group.pageNumber} className="plan-review-complete-page">
          <p className="plan-review-complete-page-label">Page {group.pageNumber}</p>
          <ul className="plan-review-complete-comment-list">
            {group.items.map((item) => (
              <li key={item.annotationId} className="plan-review-complete-comment">
                <p className="plan-review-complete-comment-text">
                  <strong>{item.authorName}</strong>
                  <span className="plan-review-complete-comment-sep"> · </span>
                  {item.content}
                  {item.replyCount > 0 ? (
                    <span className="plan-review-complete-replies">
                      {' '}
                      ({item.replyCount} {item.replyCount === 1 ? 'reply' : 'replies'})
                    </span>
                  ) : null}
                </p>
                {item.contextPreviewUrl ? (
                  <img
                    className="plan-review-complete-preview-img"
                    src={item.contextPreviewUrl}
                    alt={`Preview for comment on page ${group.pageNumber}`}
                    loading="lazy"
                  />
                ) : null}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
